import React, {useEffect, useState} from "react";
import UserService from "../services/UserService";


const NoRolesNavBar = (props) => {

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [Greeting, setGreeting] = useState('');

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const user = UserService.getCurrentUser();
        console.log("user: ", user);
        const date = new Date();
        const hour = date.getHours()
        if (hour < 12) {
            setGreeting("Good morning " + user.firstName);
        } else if (hour < 17) {
            setGreeting("Good afternoon " + user.firstName);
        } else {
            setGreeting("Good evening " + user.firstName);
        }
    }, []);


    const logOut = () => {
        UserService.logout();
        props.history.push('/');
    };
    return (
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top">
            <div className="container-fluid">
                <div className="navbar-wrapper">
                    <a className="navbar-brand" href="/">Nhaka Life Insurance</a>
                </div>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    aria-controls="navigation-index"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="navbar-toggler-icon icon-bar"/>
                    <span className="navbar-toggler-icon icon-bar"/>
                    <span className="navbar-toggler-icon icon-bar"/>
                </button>
                <div className="collapse navbar-collapse justify-content-end">
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown ml-3">
                            <a
                                className="btn btn-sm btn-primary text-white font-weight-normal"
                                href="javascript:;"
                                id="navbarDropdownProfile"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {Greeting}&nbsp;&nbsp;<i className="fa fa-user-circle"/>
                                <p className="d-lg-none d-md-block">Account</p>
                            </a>
                            <div
                                className="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbarDropdownProfile"
                            >
                                <a
                                    className="dropdown-item"
                                    onClick={logOut}
                                    href="/"
                                >
                                    <i className="fa fa-sign-out"/>&nbsp;
                                    Log out
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}


export default NoRolesNavBar;
